<script lang="ts" setup>
import { computed } from 'vue';
import PolicyTooltip from './PolicyTooltip.vue';

const props = defineProps<{
  isSelected: boolean;
  badgeContent?: string;
  padding?: string;
  isDisabled?: boolean;
  isPolicyLocked?: boolean;
}>();

const isRecommended = computed(
  () =>
    typeof props.badgeContent === 'string' && props.badgeContent.toUpperCase() === 'RECOMMENDED',
);
</script>

<template>
  <div
    class="flex flex-1 flex-col gap-2 rounded-2xl border border-tint-300"
    :class="{
      '!border-highlight-500 bg-highlight-0': isSelected,
      'text-shade-820': !isSelected,
      [props.padding || 'p-4']: true,
      'cursor-pointer': !isDisabled,
      'cursor-not-allowed': isDisabled,
    }"
  >
    <!-- Header Slot -->
    <div v-if="$slots.header" class="flex-1 text-sm font-bold"><slot name="header"></slot></div>
    <div class="flex flex-row gap-3">
      <!-- Title Slot -->
      <div class="flex-1 text-sm font-bold" v-if="$slots.title"><slot name="title"></slot></div>

      <!-- Badge -->
      <div
        v-if="badgeContent"
        class="self-center rounded px-1.5 py-1 text-2xs font-bold leading-tight text-white"
        :class="{
          'bg-highlight-500': isRecommended,
          'bg-shade-900': !isRecommended,
        }"
      >
        {{ badgeContent }}
      </div>

      <PolicyTooltip v-if="isPolicyLocked" />
    </div>

    <div class="text-sm" v-if="$slots.default">
      <slot></slot>
    </div>

    <div v-if="$slots.action">
      <slot name="action"></slot>
    </div>
  </div>
</template>
